/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, from: NonNullable<unknown>, to: NonNullable<unknown> }} Coinvestments_Report_Reportinghistory_Subtitle2Inputs */

const en_coinvestments_report_reportinghistory_subtitle2 = /** @type {(inputs: Coinvestments_Report_Reportinghistory_Subtitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} updates · ${i?.from} – ${i?.to}`)
};

/**
* | output |
* | --- |
* | "{count} updates · {from} – {to}" |
*
* @param {Coinvestments_Report_Reportinghistory_Subtitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_reportinghistory_subtitle2 = /** @type {((inputs: Coinvestments_Report_Reportinghistory_Subtitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Reportinghistory_Subtitle2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_reportinghistory_subtitle2(inputs)
});
export { coinvestments_report_reportinghistory_subtitle2 as "coInvestments_report_reportingHistory_subtitle" }